import { computed, type Ref } from "vue";

import type { Document } from "@ctrl/controller-rpc";

import type { Router } from "@/types";

import TitledDocument from "../TitledDocument.vue";

interface Value {
  notes?: Document | null;
}

//
// Document lifecycle management for default types (tasks, events, pages, contacts etc.).
//
export function useDocument<Type extends Value>(
  value: Ref<Type>,
  elt: Ref<InstanceType<typeof TitledDocument> | null | undefined>,
  router: Router
) {
  const flush = () => {
    elt.value?.flush();
    elt.value?.flushTitle();
  };

  const initializeFocus = () => {
    const focusBlock = router.currentRoute.value.query["focus-block"];
    if (focusBlock && typeof focusBlock === "string") {
      elt.value?.focusBlock(focusBlock);
    } else if (!value.value.notes || value.value.notes.blocks.length === 0) {
      elt.value?.focusEmptyTitle();
    }
  };

  const selectAll = () => {
    elt.value?.selectAll();
  };

  const hasBlockActive = computed<boolean>(
    () => !!elt.value?.hasBlockSelected() || !!elt.value?.hasBlockFocused()
  );

  return {
    flush,
    hasBlockActive,
    initializeFocus,
    selectAll,
  };
}
